import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { FlowerIcon, ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
type PriceSectionProps = {
  onCTA: () => void;
};
const badges = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ShieldCheckIcon,
  label: 'Una sola vez'
}];
export function PriceSection({
  onCTA
}: PriceSectionProps) {
  const reducedMotion = useReducedMotion();
  return <section id="precio" className="w-full scroll-mt-20 bg-crema py-20 sm:py-28" data-id="element-160" data-mp="2qkevdn4jzddq">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-161" data-mp="2mjczng9uhjgi">
        <Reveal className="text-center" data-id="element-162" data-mp="os0cakq9w2vq">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-163" data-mp="oqyyi8hvh2ab">
            Invierte en ti hoy
          </h2>
          <p className="mt-4 text-lg text-tinta/70" data-id="element-164" data-mp="1milz2knacb3k">
            Menos de lo que gastas en una salida, por 30 días que pueden cambiar
            cómo te sientes en tu cuerpo.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-165" data-mp="1di7clhyl4pyh">
          <div className="mt-10 overflow-hidden rounded-[2rem] border border-nude bg-white p-8 text-center shadow-xl shadow-rosa/15 sm:p-12" data-id="element-166" data-mp="1diz9qx7tyvqv">
            <span className="mb-8 inline-flex items-center gap-2 rounded-full bg-rosa/15 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.18em] text-rosa-dark" data-id="element-167" data-mp="1hlluke633gek">
              <FlowerIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-168" data-mp="2a6vhrdp7ciqh" />
              Oferta de lanzamiento
            </span>

            <CountdownTimer data-id="element-169" data-mp="1wgjovcksmfya" />

            <div className="mt-6 flex flex-wrap items-end justify-center gap-x-3 gap-y-2" data-id="element-170" data-mp="20idhqyoqyfnw">
              <span className="mb-1 flex h-16 w-16 shrink-0 -rotate-12 flex-col items-center justify-center rounded-full border border-rosa/40 bg-rosa/15 text-rosa-dark" data-id="element-171" data-mp="2o7zihqkrp2y0">
                <span className="font-serif text-xl font-semibold leading-none" data-id="element-172" data-mp="2szzfba5jjfqd">
                  65%
                </span>
                <span className="mt-0.5 text-[9px] font-semibold uppercase tracking-[0.12em]" data-id="element-173" data-mp="2yt37uetvdfxw">
                  Dcto
                </span>
              </span>
              <span className="font-serif text-2xl text-tinta/40 line-through" data-id="element-174" data-mp="2tsf8n5vhlssl">
                $47 USD
              </span>
              <span className="font-serif text-6xl font-semibold text-rosa-dark sm:text-7xl" data-id="element-175" data-mp="2ox9n485zyg51">
                $17
              </span>
              <span className="pb-2 text-lg font-medium text-tinta/60" data-id="element-176" data-mp="2f4kctgm6n8ba">
                USD
              </span>
            </div>
            <motion.p animate={reducedMotion ? undefined : {
            color: ['#8f7a72', '#C08E88', '#D4A5A0', '#C08E88', '#8f7a72'],
            opacity: [0.75, 1, 1, 1, 0.75],
            scale: [1, 1.06, 1.06, 1.06, 1]
          }} transition={{
            duration: 1.2,
            repeat: Infinity,
            repeatDelay: 0.5,
            ease: 'easeInOut'
          }} className="mt-2 text-sm font-semibold tracking-wide text-tinta/60" data-id="element-177" data-mp="2b4a9yctosy0n">
              Un solo pago · Acceso de por vida
            </motion.p>

            <CTAButton id="comenzar-transformacion" onClick={onCTA} icon={FlowerIcon} size="lg" className="mt-8 w-full sm:w-auto" data-id="element-178" data-mp="20z1yi8mm1j6k">
              Comenzar mi transformación
            </CTAButton>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-tinta/70" data-id="element-179" data-mp="1d8y48rvbavs8">
              {badges.map(b => <span key={b.label} className="inline-flex items-center gap-1.5" data-id="element-180" data-mp="klbs2v80qitr">
                  <b.icon className="h-4 w-4 text-dorado" strokeWidth={1.8} data-id="element-181" data-mp="pjlqrfsyc1k4" />
                  {b.label}
                </span>)}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}